import React, { Component } from 'react';
import DatePicker from 'react-date-picker';
import { toast } from 'react-toastify';
import { Row, Col, Table, Popover, OverlayTrigger } from "react-bootstrap";
import { CustomCard } from "../../components/Card/CustomCard";
import { BusquedaEst } from "../../funciones/EstudiantesFunction";
import { ConsultNotasPendientes } from "../../funciones/NotasCertificadasFunction";
import NotasPendientes from "./NotasCertContent/NotasPendientes";
import EstudiantesTable from "./NotasCertContent/EstudiantesTable";

class RepNotasCert extends Component {
    state = {
        string: "",
        preloader: "",
        textPendiente: {
            icon: "fa fa-spinner fa-spin",
            text: "Buscando solicitudes"
        },
        pendientes: [],
        resultadosEst: [],
        preloaderEst: {
            icon: "",
            text: "Ingresa una cédula, nombre o apellido para consultar"
        },
        cantPendientes: 0,
        fecha: new Date()
    }

    constructor (props) {
        super (props);

        ConsultNotasPendientes ((resp) => {
            if (resp.length === 0) {
                this.setState({
                    textPendiente: {
                        icon: "",
                        text: "No existen solicitudes de notas certificadas pendientes"
                    },
                    pendientes: resp,
                    cantPendientes: resp.length
                })
            }else{
                this.setState({
                    pendientes: resp,
                    cantPendientes: resp.length
                })
            }
        })
    }

    updateList = () => {
        ConsultNotasPendientes ((resp) => {
            if (resp.length === 0) {
                this.setState({
                    textPendiente: {
                        icon: "",
                        text: "No existen solicitudes de notas certificadas pendientes"
                    },
                    pendientes: resp,
                    cantPendientes: resp.length
                })
            }else{
                this.setState({
                    pendientes: resp,
                    cantPendientes: resp.length
                })
            }
        })
    }

    cambiaValor = (prop) => (event) => {
        this.setState({
            [prop]: event.target.value 
        });
    };

    cambiaFecha = (date) => {
        this.setState({
            fecha: date,
        });
    }

    enterTab = () => (e) => {
        if (e.which === 13){
            if (this.state.string === "") return null;
            
            this.setState ({
                resultadosEst: [],
                preloaderEst: {
                    icon: "fa fa-spinner fa-spin",
                    text: "Buscando solicitudes"
                }
            }, () => {
                BusquedaEst (this.state.string, (resp) => {
                    if (resp.length === 0) {
                        toast.error("No se encontró ninguna coincidencia",{autoClose: 4000});
                        this.setState ({
                            preloaderEst: {
                                icon: "",
                                text: "La búsqueda no obtuvo resultados"
                            },
                            resultadosEst: []
                        })
                        return null
                    }
                    this.setState ({
                        preloaderEst: "",
                        resultadosEst: resp
                    })
                })
            })
        }
    }

    ayuda = () => (
        <React.Fragment>
            <Row>
                <Col md={12} align="justify">
                    En esta sección puedes imprimir las Notas Certificadas o Simples (según sea el caso)
                </Col>
                <Col md={12} className="custom-mt-10">
                    <a style={{color:"#1f2f6e"}}><i className="fa fa-calendar"></i> Fecha de impresión</a>
                </Col>
                <Col md={12} align="justify">
                    Corresponde a la fecha que aparecerá en el formato y se encuentra por defecto en la fecha actual del equipo. Para cambiarla haz click en ella y selecciona primero el año, luego el mes y por último el día.
                </Col>
                <Col md={12} className="custom-mt-10">
                    <a style={{color:"#cfab75"}}> <i className="fa fa-clone"></i> Solicitudes Pendientes</a>
                </Col>
                <Col md={12} align="justify">
                    Este es el listado de solicitudes pendientes disponibles. En la columna <strong>Tipo</strong> específica si la nota es Simple o Certificada.
                </Col>
                <Col md={12} align="justify">
                    El botón <button className="btn btn-primary btn-xs" style={{borderWidth: 1}}><i className="fa fa-gear"></i> Acciones</button> permite <a className="text-primary">Aprobar e imprimir</a> la solicitud o <a className="text-danger">Cancelarla</a>. En ambos casos se le enviará una notificación por email al estudiante.
                </Col>
                <Col md={12} className="custom-mt-10">
                    <a style={{color:"#32704C"}}> <i className="fa fa-search"></i> Búsqueda de Estudiantes</a>
                </Col>
                <Col md={12} align="justify">
                    Ingresa la cédula, un nombre o un apellido del estudiante para mostrar una lista con el o los resultados obtenidos.
                </Col>
                <Col md={12} align="justify">
                    Una vez hecha la consulta verás una lista de estudiantes y un botón <button className="btn btn-primary btn-xs" style={{borderWidth: 1}}><i className="fa fa-gear"></i> Acciones</button> que permite imprimir: <div className="text-primary" style={{marginLeft: 10,}}><i className="fa fa-file-o"></i> Notas Simples</div><div className="text-warning" style={{marginLeft: 10,}}><i className="fa fa-file"></i> Notas Certificadas</div> según sea el caso.
                </Col>
                <Col md={12} align="justify">
                    El estudiante que solicita las notas debe estar registrado como usuario en sistema
                </Col>
            </Row>
        </React.Fragment>
    )

    lisEstudiantes = () => {
        let { resultadosEst, preloaderEst, fecha } = this.state;

        if (resultadosEst.length === 0) return (
            <tr>
                <td colSpan={4} align="center"><i className={preloaderEst.icon}></i> {preloaderEst.text}</td>
            </tr>
        )

        return(
            resultadosEst.map(option => (
                <EstudiantesTable
                key={option.id_estudiante}
                data={option}
                fecha = {fecha}
                />
            ))
        )
    }

    lisPendientes = () => {
        let { textPendiente, pendientes, fecha } = this.state;

        if (pendientes.length === 0) return (
            <tr>
                <td colSpan={5} align="center"><i className={textPendiente.icon}></i> {textPendiente.text}</td>
            </tr>
        )

        return (
            pendientes.map (option => (
                <NotasPendientes
                    key = {option.id}
                    datos = {option}
                    fecha = {fecha}
                    updateList = {() => { this.updateList() }}
                />
            ))
        )
    }

    render() {
        let { string, preloader, cantPendientes, fecha } = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        return (
            <div className="content">
                <Row>
                    <Col md={8}>
                        <div className="custom-alert-info" style={{padding: 5}}>
                            <Row>
                                <Col md={6} style={{marginTop: 12}}>
                                    <i className="fa fa-calendar"></i> Fecha de Impresión
                                </Col>
                                <Col md={6}>
                                    <DatePicker
                                        minDate = {new Date(2001, 1, 1)}
                                        maxDate = {new Date(2099, 1, 1)}
                                        clearIcon = {<i className="fa fa-times"></i>}
                                        calendarIcon = {<i className="fa fa-calendar"></i>}
                                        className = "form-control"
                                        onChange = {this.cambiaFecha}
                                        value = {fecha}
                                    />
                                </Col>
                            </Row>
                        </div>
                        <div className="custom-alert-warning custom-mt-10" style={{padding: 5}}>
                            <div><i className="fa fa-clone"></i> Solicitudes Pendientes <strong>({cantPendientes})</strong><i className={preloader}></i></div>
                        </div>
                        <div className="table-responsive custom-mt-10" style={{backgroundColor:"#FFF", overflowX:"hidden", overflowY: "auto", maxHeight: 200}}>
                            <Table striped hover bordered>
                                <tbody>
                                    <tr className="custon-back-color-warning">
                                        <td align="center" width="15%" style={styles}><strong>C.I.</strong></td>
                                        <td width="40%" style={styles}><strong>Estudiante</strong></td>
                                        <td align="center" width="30%" style={styles}><strong>Carrera</strong></td>
                                        <td align="center" width="15%" style={styles}><strong>Tipo</strong></td>
                                        <td align="center" width="100px" style={styles}><strong>Acciones</strong></td>
                                    </tr>
                                    {this.lisPendientes()}
                                </tbody>
                            </Table>
                        </div>

                        <div className="custom-alert-success custom-mt-10" style={{padding: 5}}>
                            <div><i className="fa fa-search"></i> Búsqueda de Estudiantes <i className={preloader}></i></div>
                            <input type="text" value ={string} onChange={this.cambiaValor("string")} onKeyPress={this.enterTab()} className="form-control" placeholder="Ingresa la C.I., nombre o apellido del estudiante"/>
                        </div>
                        <div className="table-responsive custom-mt-10" style={{backgroundColor:"#FFF"}}>
                            <Table striped hover bordered>
                                <tbody>
                                    <tr className="custon-back-color">
                                        <td align="center" width="15%" style={styles}><strong>C.I.</strong></td>
                                        <td width="50%" style={styles}><strong>Estudiante</strong></td>
                                        <td align="center" width="35%" style={styles}><strong>Carrera</strong></td>
                                        <td align="center" width="100px" style={styles}><strong>Acciones</strong></td>
                                    </tr>
                                    {this.lisEstudiantes()}
                                </tbody>
                            </Table>
                        </div>
                    </Col>
                    <Col md={4}>
                        <div style={{borderRadius: "4px 4px",}}>
                            <CustomCard
                                styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                category={<span style={{color: "#fff"}}>Notas Certificadas</span>}
                                color="#a80012"
                                content={this.ayuda()}
                            />
                        </div>
                    </Col>
                </Row>
            </div>    
        );
    }
}
 
export default RepNotasCert;


// WEBPACK FOOTER //
// ./src/views/Reportes/RepNotasCert.jsx